module.exports = __webpack_public_path__ + "files/99a97d1c0b1ff147d58f28b458e26216.png";